import { render, staticRenderFns } from "./ListCategories.vue?vue&type=template&id=ed8df358&scoped=true"
import script from "./ListCategories.vue?vue&type=script&lang=ts"
export * from "./ListCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8df358",
  null
  
)

export default component.exports